var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-cloud"},[_c('div',{staticClass:"span1 SourceHanSansCN"},[_vm._v("开通企业云官网")]),_c('div',{staticClass:"span2"},[_vm._v("让更多企业的价值被发现")]),_c('el-button',{staticClass:"default-button",on:{"click":_vm.opening}},[_vm._v("立即开通")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }